import * as React from "react";
import { useLocation } from "react-router";
import ReactGA from "react-ga4";
import MetaPixel from "@utils/meta/MetaPixel";

const Analytics: React.FC = () => {
  let location = useLocation();

  React.useEffect(() => {
    ReactGA.set({ page: location.pathname });
    ReactGA.send({ hitType: "pageview", page: location.pathname });
    MetaPixel.pageView();
  }, [location]);

  return <div></div>;
};

export default Analytics;
